// extracted by mini-css-extract-plugin
export default {"blocksWrapper":"Lhewn","wrapper":"CV5bV"};